import { formatPriceByLanguage } from 'ggApp/utils/money';

const getRawTotalPrices = (products = []) => {
    const filteredProducts = products.filter(Boolean);

    return filteredProducts.reduce(
        (sum, { planPrice, planOldPrice }) => {
            return {
                rawTotalBundlePrice: sum.rawTotalBundlePrice + planPrice,
                rawTotalOldBundlePrice: sum.rawTotalOldBundlePrice + planOldPrice,
            };
        },
        { rawTotalBundlePrice: 0, rawTotalOldBundlePrice: 0 },
    );
};

export const formatBundleDetails = ({
    productList,
    planDuration,
    language,
    currency,
    currentVariant,
}) => {
    if (!(productList.length && planDuration && language && currency)) return null;

    const products = productList
        .map((product) => {
            const selectedPlan = product.rentalPlans.find(
                (plan) => plan?.length?.value === planDuration,
            );
            if (!selectedPlan) return null;
            const selectedVariant =
                // eslint-disable-next-line eqeqeq
                product.variants.find((variant) => variant.id == currentVariant?.id) ||
                product.variants[0];

            return {
                name: product.name,
                sku: product.sku,
                variant: {
                    id: parseInt(selectedVariant.id, 10),
                    sku: selectedVariant.sku,
                    imageUrl: selectedVariant?.imageUrl,
                },
                planLength: selectedPlan?.length?.value,
                planOldPrice: selectedPlan?.oldPrice?.inCents || selectedPlan?.price?.inCents,
                planPrice: selectedPlan?.price?.inCents,
                planId: parseInt(selectedPlan?.id, 10),
                quantity: 1,
                minimumMonths: selectedPlan?.length?.value,
            };
        })
        .filter(Boolean);
    const { rawTotalBundlePrice, rawTotalOldBundlePrice } = getRawTotalPrices(products);
    return {
        products,
        rawTotalOldBundlePrice,
        rawTotalBundlePrice,
        totalOldBundlePrice:
            rawTotalBundlePrice !== rawTotalOldBundlePrice
                ? formatPriceByLanguage(rawTotalOldBundlePrice, currency, language)
                : null,
        totalBundlePrice: formatPriceByLanguage(rawTotalBundlePrice, currency, language),
    };
};
